export const getMaxStayForDate = ({
  maximumStays = [],
  selectedRatePlanId,
}) => {
  const maxStayObj =
    typeof maximumStays === "object"
      ? maximumStays.find((item) => item.ratePlanId === selectedRatePlanId)
      : null;
  const maxStayForDate = maxStayObj ? maxStayObj.maxStay : 0;

  return maxStayForDate;
};
